const TRAVELER_FORM_SECTION_NAME = 'traveler-section';
const TRAVELER_FIRST_NAME = 'traveler-firstName';
const TRAVELER_LAST_NAME = 'traveler-lastName';
export default {
  TRAVELER_FORM_SECTION_NAME,
  TRAVELER_FIRST_NAME,
  TRAVELER_LAST_NAME
};
//# sourceMappingURL=travelerInputs.js.map